import { IsNotEmpty, IsUUID, IsString, MinLength, MaxLength } from 'class-validator';

export class RouteTradeRequestOfferActionDTO {

    @IsNotEmpty()
    @IsUUID()
    requestId: string;

    @IsNotEmpty()
    @IsUUID()
    offerId: string;

    @IsNotEmpty()
    @IsString()
    @MinLength(6)
    @MaxLength(7)
    action: string;

}
